<template>
  <div id="DaneWyjsciowe">
    <h4>{{$t('message.output_data')}}</h4>
    <!-- <form v-on:submit.prevent="onSubmit"> -->
      <div class="form-group">
        <label for="moc_naglosnienia">{{$t('message.moc_naglosnienia')}}</label>
        <input type="text" class="form-control form-control-sm" id="moc_naglosnienia" readonly v-model="inputs.moc_systemu.value">
      </div>
      <div class="form-group">
        <label for="liczba_lini">{{$t('message.liczba_lini')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="liczba_lini" readonly v-model="outputs.liczba_lini.value">
      </div>
      <div class="form-group">
        <label for="moc_zasilacza">{{$t('message.moc_zasilacza')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="moc_zasilacza" readonly v-model="outputs.zasilacz.attributes.moc">
      </div>
      <div class="form-group">
        <label for="akumulatory_typ">{{$t('message.akumulatory')}}</label>
        <button class="btn" @click="showDialogAkumulatory = true" style="font-size: 12px; line-height: 0px; margin-right: 4px; padding: 5px;">{{$t('message.zmien')}}</button>
        <input type="text" value="" class="form-control form-control-sm" id="akumulatory_typ" style="width:92px" readonly v-model="outputs.akumulator.kod">
      </div>
      <div class="form-group">
        <label for="akumulatory_liczba">{{$t('message.liczba_akumulatorow')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="akumulatory_liczba" readonly v-model="outputs.akumulator.ilosc">
      </div>
      <div class="form-group">
        <label for="akumulatory_zapas">{{$t('message.zapas_poj_akum')}}</label>
        <input type="text" value="" :class="{ error: (outputs.zapas_pojemnosci.value<0)}" class="form-control form-control-sm" id="akumulatory_zapas" readonly v-model="outputs.zapas_pojemnosci.value">
      </div>
      <div class="form-group">
        <label for="przylacze_zasilania" class="shortLabel">{{$t('message.przylacze')}}</label>
        <button v-if="!disable_change_phase.value" @click="showDialogPrzylacze = true" style="font-size: 12px; line-height: 0px; margin-right: 4px; padding: 5px;" class="btn">{{$t('message.zmien')}}</button>
        <input type="text" value="" class="form-control form-control-sm" style="width:146px" id="przylacze_zasilania" readonly v-model="outputs.przylacze_zasilania.value">
      </div>
      <div class="form-group">
        <label for="pobor_pradu">{{$t('message.max_pobor_pradu')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="pobor_pradu" readonly v-model="pobor_pradu">
      </div>
      <div class="form-group">
        <label for="moc_cieplna" style="line-height:15px;padding: 2px;">{{$t('message.max_moc_cieplna')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="moc_cieplna" readonly v-model="outputs.moc_cieplna.value">
      </div>
      <div class="form-group">
        <label for="zabezp_bezpiecznikowe">{{$t('message.zabez_bezp')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="zabezp_bezpiecznikowe" readonly v-model="zabezpieczenia">
      </div>

      <div class="form-group">
        <label for="szafa_wolne_miejsce">{{$t('message.wolne_u')}}</label>
        <input type="text" value="" :class="{ error: (outputs.szafa_wolne_miejsce.value<0)}" class="form-control form-control-sm" id="szafa_wolne_miejsce" readonly v-model="outputs.szafa_wolne_miejsce.value">
      </div>
      <div class="form-group">
        <label for="szafa_wysokosc">{{$t('message.wys_szafy')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="szafa_wysokosc" readonly v-model="outputs.szafa.attributes.wysokosc">
      </div>
      <div class="form-group">
        <label for="szafa_wysokosc_mm">{{$t('message.wys_szafy_mm')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="szafa_wysokosc_mm" readonly v-model="outputs.szafa.attributes.mm">
      </div>
      <div class="form-group">
        <label for="szafa_rozmiar">{{$t('message.rozmiar_szafy')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="szafa_rozmiar" readonly v-model="szafaRozmiar">
      </div>

      <div class="form-group">
        <label for="szafa_waga">{{$t('message.waga_szafy')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="szafa_waga" readonly v-model="outputs.szafa.attributes.waga">
      </div>
      <div class="form-group">
        <label for="akumulatory_waga">{{$t('message.waga_akum')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="akumulatory_waga" readonly v-model="outputs.akumulator.waga">
      </div>
      <div class="form-group">
        <label for="waga_instalacyjna" style="line-height:15px" v-html="$t('message.waga_instal')"></label>
        <input type="text" value="" class="form-control form-control-sm" id="waga_instalacyjna" readonly v-model="outputs.waga_instalacyjna.value">
      </div>

      <hr>

      <template  v-if="$i18n.locale === 'pl'">
      <div class="form-group">
        <label for="rabat" class="shortLabel">{{$t('message.rabat_cenowy')}}</label>
        <md-avatar>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill iconInfo" viewBox="0 0 16 16">
          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
        </svg>
          <md-tooltip md-direction="left" class="tooltipShort" v-html="$t('message.info_rabat')"></md-tooltip>
        </md-avatar>
        <!-- onkeypress="return event.keyCode != 13;" -->
        <input type="number" value="0" min=0 max=99 class="form-control form-control-sm" id="rabat"
        v-model="outputData.rabat.value"
        @change="checkValue('rabat')">
      </div>
      <div class="form-group">
        <label for="cena_netto_systemu">{{$t('message.cena_systemu')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="cena_netto_systemu" readonly v-model="outputs.cena_netto_systemu.value">
      </div>
      <div class="form-group">
        <label for="cena_netto_calkowita">{{$t('message.cena_cala')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="cena_netto_calkowita" readonly v-model="outputs.cena_netto_calkowita.value">
      </div>
      <div class="form-group" v-if="outputData.rabat.value>0">
        <label for="cena_netto_calkowita">{{$t('message.cena_net_sztuka')}}</label>
        <input type="text" value="" class="form-control form-control-sm" id="cena_netto_calkowita" readonly v-model="outputs.cena_netto_bez_rabatu.value">
      </div>

      <div class="margin"></div>
      <span style="text-align: left;width: 100%;display: block;font-weight: bold;font-size: 12px;line-height: 12px;">{{$t('message.info_o_zamowieniu')}}</span>
      <span style="text-align: left;width: 100%;display: block; font-weight:bold;font-size: 12px;">{{$t('message.trans')}}</span>
      </template>
      <!-- <hr> -->

      <h4>{{$t('message.numer_konfi')}}
        <span @click="active = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square iconEditCode" viewBox="0 0 16 16">
            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
          </svg>
        </span></h4>
      <div class="form-group">
        <!-- <label for="numer_konfiguracji" style="width: 120px;">Nr konfiguracji: </label> -->
        <input type="text" style="width: 100%;" class="form-control form-control-sm" id="numer_konfiguracji"
        v-model="outputs.numer_konfiguracji.value" readonly>
      </div>
    <!-- </form> -->

    <md-dialog-prompt
    class="prompt"
      :md-active.sync="active"
      v-model="numer"
      md-title="Numer konfiguracji"
      md-input-maxlength="28"
      md-input-placeholder="podaj numer ..."
      md-confirm-text="Zapisz"
      md-cancel-text="Anuluj"/>

    <div class="form-group" style="float:right; display:block; margin:3px 0px">
      <button class="btn btn-primary" @click="pokaz_zestawienie = true" style="">{{$t('message.zestawienie')}}</button>
    </div>

    <!-- {{outputData.pobor_pradu}}
    {{outputData.przylacze_zasilania}} -->

    <Podsumowanie
      :showDialog="pokaz_zestawienie"
      @clickedClose="closedDialog"
    />
    <MozliweAkumulatory
      :showDialog="showDialogAkumulatory"
      @clickedClose="closedDialog"
    />
    <PrzylaczeZasilania
      :showDialog="showDialogPrzylacze"
      @clickedClose="closedDialog"
    />

  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

import Podsumowanie from './Dialogs/Podsumowanie.vue'
import MozliweAkumulatory from './Dialogs/MozliweAkumulatory'
import PrzylaczeZasilania from './Dialogs/PrzylaczeZasilania'

export default {
  name: 'DaneWyjsciowe',
  mixins: [app, materials, calculation],
  data () {
    return {
      active: false,
      numer: null,
      pokaz_zestawienie: false,
      showDialogAkumulatory: false,
      showDialogPrzylacze: false,
      outputData: {
        moc_naglosnienia: {'value': ''},
        liczba_lini: {'value': 0},
        moc_zasilacza: {'value': 0},
        akumulatory_typ: {'value': 0},
        akumulatory_liczba: {'value': 0},
        akumulatory_zapas: {'value': 0},
        akumulatory_waga: {'value': 0},
        przylacze_zasilania: {'value': 0},
        pobor_pradu: {'value': 0},
        moc_cieplna: {'value': 0},
        zabezp_bezpiecznikowe: {'value': 0},
        szafa_wolne_miejsce: {'value': 0},
        szafa_wysokosc: {'value': 0},
        szafa_wysokosc_mm: {'value': 0},
        szafa_rozmiar: {'value': 0},
        szafa_waga: {'value': 0},
        waga_instalacyjna: {'value': 0},
        rabat: {'value': 0},
        cena_netto_systemu: {'value': 0},
        cena_netto_bez_rabatu: {'value': 0},
        numer_konfiguracji: {'value': ''}
      }
    }
  },
  components: {
    Podsumowanie, MozliweAkumulatory, PrzylaczeZasilania
  },
  computed: {
    ...mapState('app', ['disable_change_phase']),
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaAkcesoria']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaZasilacze']),
    ...mapGetters('products', ['ListaListwyD']),
    ...mapGetters('products', ['ListaListwyZ']),
    ...mapGetters('products', ['ListaMaterialy']),

    szafaRozmiar () {
      if (this.outputs.szafa.attributes.szerokosc !== '' && this.outputs.szafa.attributes.glebokosc !== '') {
        return this.outputs.szafa.attributes.szerokosc + 'x' + this.outputs.szafa.attributes.glebokosc
      } else {
        return ''
      }
    },
    pobor_pradu () {
      if (this.outputs.ilosc_faz.value > 0 && this.outputs.pobor_pradu.value > 0) {
        return this.outputs.ilosc_faz.value + 'x' + this.outputs.pobor_pradu.value.toFixed(1)
      } else {
        return ''
      }
    },
    zabezpieczenia () {
      if (this.outputs.ilosc_faz.value > 0 && this.outputs.zabezpieczenia.value > 0) {
        return this.outputs.ilosc_faz.value + 'x' + this.outputs.zabezpieczenia.value
      } else {
        return ''
      }
    }
  },
  watch: {
    outputs: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        Object.keys(this.outputData).forEach(element => {
          this.outputData[element]['value'] = newValue[element].value
        })
      }
    },
    numer (newValue, oldValue) {
      this.wprowadz_numer(newValue.toUpperCase())
    }
  },
  methods: {
    onSubmit () {

    },
    closedDialog (bool) {
      this.pokaz_zestawienie = bool
      this.showDialogAkumulatory = bool
      this.showDialogPrzylacze = bool
    },
    wprowadz_numer (item) {
      // DSOP24V-13-12-24/17061111700
      // DSOP24V-13-12-24/17061111700
      // console.log('item: ', item)
      var len = item.length
      var kontroler = item.substr(8, 1)
      var router = item.substr(9, 1)
      var wzmRez = item.substr(11, 1)
      var wzm = item.substr(12, 1)
      var czas = item.substr(14, 2)
      // var zasilacz = item.substr(17, 2)
      // var akum = item.substr(19, 2)
      // var listwaD = item.substr(21, 1)
      // var listwaZ = item.substr(22, 1)
      // var panelSygnal = item.substr(23, 1)
      var PanelWentyl = item.substr(24, 1)
      var szafa = item.substr(25, 1)
      var mikrofon = item.substr(26, 1)
      var kolka = item.substr(27, 1)

      var searchDSOP = 'DSOP24V-'
      var indexOfFirst = item.indexOf(searchDSOP)

      if (indexOfFirst === 0 && len === 28) {
        this.changeValueInputs('kontroler', 'value', Number(kontroler))
        this.changeValueInputs('router', 'value', Number(router))
        this.changeValueInputs('wzmacniacz_rezerwowy', 'value', Number(wzmRez))
        this.changeValueInputs('wzmacniacz', 'value', Number(wzm))

        var matchSzafa = []
        matchSzafa = this.ListaSzafy.filter(item => (item.gen_code === szafa))
        this.changeValueOutputs('szafa', 'array', matchSzafa[0])
        this.changeValueOutputs('szafa_user', 'value', true)

        if (czas === '06') {
          czas = 6
        }

        this.changeValueInputs('czas_podtrzymania', 'value', Number(czas))

        this.changeValueInputs('panel_wentylacyjny', 'value', Number(PanelWentyl))
        this.changeValueInputs('wariant1', 'value', Number(mikrofon))
        this.changeValueInputs('kolka', 'value', Number(kolka))

        if (Number(wzm) > 0) {
          // this.changeValueInputs('wzmacniacz_rezerwowy', 'max', (this.inputData[labelName].max - this.inputData[labelName].value))
          this.changeValueInputs('sygnal_pilota', 'max', (1000 * Number(wzm)))
          this.changeValueInputs('sygnal_pilota', 'value', (1000 * Number(wzm)))
          this.changeValueInputs('moc_glosnikow', 'max', (1000 * Number(wzm)))
          this.changeValueInputs('moc_glosnikow', 'value', (1000 * Number(wzm)))
          this.changeValueInputs('moc_systemu', 'max', (1000 * Number(wzm)))
          this.changeValueInputs('moc_systemu', 'value', (1000 * Number(wzm)))

          if (Number(wzm) > 0) {
            this.changeValueInputs('sygnal_pilota_cb', 'value', true)
          } else {
            this.changeValueInputs('sygnal_pilota_cb', 'value', false)
            this.changeValueInputs('sygnal_pilota', 'value', 0)
          }
        }

        if (Number(wzm) > 0) {
          // this.changeValueInputs('wzmacniacz', 'max', (this.inputData['wzmacniacz'].max - this.inputData[labelName].value))
        }

        this.obliczenia_sprzetu()
      }
    }
  }
}
</script>

<style scoped>
.btn-primary {
padding: 0px 16px; font-size: 15px;
transition: all .5s;
height: 30px;
color: #fff;
background-color: rgb(59, 163, 255);
border-color:rgb(59, 163, 255);
}
.btn-primary:hover {
color: #3ba3ff;
  background: white;
}
.iconEditCode {
float: right; cursor: pointer;
}
.iconInfo {
  margin-right: 4px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;
}
.iconInfo:hover {
  background: #3ba3ff; color: #fff; border: 2px;  border: 1px solid #3ba3ff;
}
.error {
  color:red
}
hr.new {
  border: 2px solid #1F5D89;
  border-radius: 5px;
  width: 300px;
  margin: 0px auto;
}
.dialogZestawienie {
min-height: 892px;
max-height: 892px;
}
#zestawienie div.md-dialog-container {
  width:820px !important;
  max-width: 820px !important;
  max-width: 820px !important;

}
  .md-avatar[data-v-1b4e33f8] {
      width: 0px;
      min-width: 20px;
      height: 28px;
      border-radius: 0px;
      margin-left: 34px;
      margin-right: 10px;
  }
  .tooltipShort  {
    padding:10px;
    width:300px;
    height:110px;
    font-size: 14px;
  }
  .md-dialog-title {
    margin-bottom: 0px;
    padding: 0px 0px 0;
    text-align: center;
    color:  #1F5D89;
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/DaneWyjsciowe.vue